import { render, staticRenderFns } from "./list_checkhole.vue?vue&type=template&id=0b451941&scoped=true&"
import script from "./list_checkhole.vue?vue&type=script&lang=js&"
export * from "./list_checkhole.vue?vue&type=script&lang=js&"
import style0 from "./list_checkhole.vue?vue&type=style&index=0&id=0b451941&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b451941",
  null
  
)

export default component.exports